module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr5-9bb560ececc5425aace9d47108107fa9.jpg";